import { __exports as u } from "./index143.js";
import "./index79.js";
import "./index163.js";
import { __exports as A } from "./index83.js";
import { __exports as C } from "./index164.js";
Object.defineProperty(u, "__esModule", { value: !0 });
u.formatAttributes = d;
u.hasOpenTag = g;
u.escapeSpecialCharacters = b;
u.revertEscapedCharacters = m;
u.formatDOM = R;
var f = A, l = C;
function T(e) {
  return l.CASE_SENSITIVE_TAG_NAMES_MAP[e];
}
function d(e) {
  for (var a = {}, n = 0, o = e.length; n < o; n++) {
    var t = e[n];
    a[t.name] = t.value;
  }
  return a;
}
function x(e) {
  e = e.toLowerCase();
  var a = T(e);
  return a || e;
}
function g(e, a) {
  var n = "<" + a, o = e.toLowerCase().indexOf(n);
  if (o === -1)
    return !1;
  var t = e[o + n.length];
  return t === ">" || t === " " || t === "	" || t === `
` || t === "\r" || t === "/";
}
function b(e) {
  return e.replace(l.CARRIAGE_RETURN_REGEX, l.CARRIAGE_RETURN_PLACEHOLDER);
}
function m(e) {
  return e.replace(l.CARRIAGE_RETURN_PLACEHOLDER_REGEX, l.CARRIAGE_RETURN);
}
function R(e, a, n) {
  var o, t, v, _;
  a === void 0 && (a = null);
  for (var s = [], r, c = 0, h = e.length; c < h; c++) {
    var i = e[c];
    switch (i.nodeType) {
      case 1: {
        var E = x(i.nodeName);
        r = new f.Element(E, d(i.attributes)), r.children = R(
          // template children are on content
          E === "template" ? i.content.childNodes : i.childNodes,
          r
        );
        break;
      }
      case 3:
        r = new f.Text(m((o = i.nodeValue) !== null && o !== void 0 ? o : ""));
        break;
      case 8:
        r = new f.Comment((t = i.nodeValue) !== null && t !== void 0 ? t : "");
        break;
      default:
        continue;
    }
    var p = (v = s[c - 1]) !== null && v !== void 0 ? v : null;
    p && (p.next = r), r.parent = a, r.prev = p, r.next = null, s.push(r);
  }
  return n && (r = new f.ProcessingInstruction(n.substring(0, n.indexOf(" ")).toLowerCase(), n), r.next = (_ = s[0]) !== null && _ !== void 0 ? _ : null, r.parent = a, s.unshift(r), s[1] && (s[1].prev = s[0])), s;
}
export {
  u as default
};
